/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function StrategicPartnerDetails() {
    return (
        <div>
            <PageSeo title="Silicon Valley Bank | The Gender Index" pathname={ROUTES.headlinePartnersSiliconValleyBank}/>
            <Layout>

                <div className='singleLayout partnerDetailsPage'>
                    <div className='edgeBannerWrapper'>
                        <div className='edgeBanner'>
                        </div>
                        <div className="bannerDetailsWrap">
                            <div className="leftPane">
                                <Link className="backBtn" href="/strategic-partners">&lt; Back</Link>
                                <h4>Strategic partner</h4>
                                <h1>Silicon Valley Bank (SVB)</h1>
                                <ul className="commonList link">
                                    <li><a href="https://www.svb.com/uk" target="_blank" rel="noreferrer">www.svb.com/uk</a></li>
                                    <li><a href="https://www.linkedin.com/company/svb-uk/" target="_blank" rel="noreferrer">www.linkedin.com/company/svb-uk/</a></li>
                                    <li>@SVB_UK</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="logo-image natwest">
                        {/* <img src="/images/PartnerLogos/svb-new.png" alt="logo_image" /> */}
                        <Image
                            src="/images/PartnerLogos/svb-new.png"
                            alt="logo_image"
                            width={232}
                            height={50}
                            loading="lazy"
                        />
                    </div>
                    <p className='body-default-copy-large'>SVB UK provides commercial banking services, expertise and insights to the technology, life science and healthcare, private equity, and venture capital industries. SVB UK is now part of HSBC Group, benefiting from its international reach to help fuel its clients’ growth.</p>
                    <h6>Why SVB UK is supporting The Gender Index:</h6>
                    <p className='body-default-copy-large'>Inspiring innovation through inclusivity. As the partner to the innovation economy, we know that bringing together diverse people sparks the kind of ideas that lead to a better, more equitable world. We also understand that
                        inspiration is only part of the equation. That ambition is empty unless it’s matched by action. That’s why we are so proud to support The Gender Index. Benchmarking the UK’s female business community is a powerful opportunity to
                        reflect on our progress as a community, and to highlight the work that’s still to be done. Understanding the realities of gender equality, access to finance, and the current landscape for female entrepreneurs empowers our ecosystem to
                        create and sustain change as we all build towards a future that is more inclusive, and therefore more innovative.</p>
                    <h6>SVB UK programmes and initiatives to support female entrepreneurs:</h6>
                    <p className='body-default-copy-large'>A business built to take action. We believe that gender equality will remain central to the sustained progress of our society, and our business. That is why it is critical that we support the visionary female founders and entrepreneurs
                        striving to drive innovation economy forward. In addition to working on external programs with partners like The Gender Index, we have made a firm strategic commitment to building the most inclusive business possible. Built around
                        three key areas – Talent, Inclusion, and Ecosystem – our DEI strategy comprises 21 initiatives designed to enhance our business, while empowering our clients, suppliers, and the broader ecosystem to evolve. From clear leadership
                        representation targets to our dynamic Employee Resource Groups, we are positioning ourselves to drive long-term change through active advocacy.</p>
                    {/* <div className="flex">
                        <h6 className="mr8">Website:</h6>
                        <a className="linkText" href="www.sbv.com/uk" target="_blank">www.sbv.com/uk</a>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">Twitter:</h6>
                        <span>@SVB_UK</span>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">LinkedIn:</h6>
                        <a className="linkText" href="www.sbv.com/uk" target="_blank">www.sbv.com/uk</a>
                    </div> */}
                </div>
            </Layout >
        </div >
    );
}

